<template>
	<div class="banner8">
		<div class="banner8containtImg">
			<img src="../../assets/group.png" >
		</div>
		<div class="banner8containtText">
			<p>
				{{$i18n.locale == 'cn' ? '重庆灏瀚网络科技有限公司' : 'GAMEHAUS PTE. LTD.'}}
			</p>
			<p v-if="$i18n.locale == 'cn'">
				<van-icon name="location-o" /> 重庆 ｜ 上海 ｜ 北京 ｜ 西安 ｜ 深圳
			</p>
			<p>
				<span>
					
					{{$i18n.locale == 'cn' ? '邮箱地址: support@gamehaus.com' : 'E-mail: support@gamehaus.com'}}
				</span>
				<br/>
			</p>
		</div>
		<!-- <p class="tips">
			<a href="https://beian.miit.gov.cn" target="view_window">渝ICP备2021006462号</a>
			<a style="margin-left: 10px;" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50010802004170" target="view_window">
				<img style="vertical-align: bottom; width: 18px;" src="../../assets/beian.png" alt="">
				渝公网安备 50010802004170号
			</a>
		</p> -->
	</div>
</template>

<script>
	export default {
		props: ['curpage'],
		data() {
			return {
				
			}
		},
		watch: {
			'curpage': {
				handler(newvalue, oldvalue) {
					// if (newvalue === 8) {
					// 	this.sliderIndex = 0
					// }
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	/deep/ .slider-btn {
		display: none !important;
	}
	/deep/ .slider-indicator-active {
		background-color: #fff !important;
	}
	body {
		background-color: red;
	}
	.banner8 {
		height: 100vh;
		// background-image: url('../../assets/bg.jpg');
		background-repeat:no-repeat;
		background-size: 100%;
		background-size: cover;
		text-align: left;
		box-sizing: border-box;
		font-family: 'PilatTest-Bold';
		padding: 2.575rem 1.25rem;
		padding-left: 1.5625rem;
		background-color: #808080;
		// overflow-y: auto;
		// overscroll-behavior: auto contain;
		.banner8containtImg {
			height: 100%;
			// width: 90%;
			box-sizing: border-box;
      margin: 0 auto;
      text-align: center;
			img {
				height: 100%;
        margin: 0 auto;
				// width: 100%;
			}
		}
		.banner8containtText {
			// position: absolute;
			box-sizing: border-box;
			box-sizing: border-box;
			color: #fff;
			// margin-top: 5px;
			background-color: #808080;
			width: 100%;
      text-align: center;
      margin-top: 0.2rem;
			p {
				font-size: 0.4rem;
				box-sizing: border-box;
				// line-height: 28px;
				padding: 1px 0;
				margin: 0;
			}
		}
		.tips {
			// font-size: 10px;
			color: #E2E2E2;
			font-weight: 400;
			text-decoration:none;
			width: 100vw;
			// background-color: red;
			text-align: center;

			font-size: 0.2025rem;
			margin-top: 5px;
			line-height: 20px;
			a {
				text-decoration:none;
				color: #E2E2E2;
				font-weight: 400;
			}
		}
	}
</style>
